module.exports = {
      id: "ios-small-usage",
      viewBox: "0 0 448 512",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#ios-small",
      toString: function () {
        return this.url;
      }
    }